module.exports = __webpack_public_path__ + "img/wf-documentation-example.adf768c8.svg";